module.exports = __webpack_public_path__ + "img/Artithon.36190ddc.png";